const CONFIG_SELECTOR = '[data-study-source-config]';
const CONTENT_SELECTOR = '[data-study-source-markers]';
const EXCLUDED_SELECTOR = 'a, sup, script, style, textarea, input, option, code, pre, [data-study-source-section]';
const SOURCE_TOKEN_PATTERN = /\[(\d+)\]/g;

function getSourceTargets() {
  const sourceTargets = new Map();

  document.querySelectorAll(CONFIG_SELECTOR).forEach((configElement) => {
    try {
      const config = JSON.parse(configElement.textContent);

      for (const source of config.sources || []) {
        if (source.number && source.targetId) {
          sourceTargets.set(String(source.number), String(source.targetId));
        }
      }
    } catch (error) {
      console.error('Could not parse clinical study source configuration.', error);
    }
  });

  return sourceTargets;
}

function createSourceMarker(number, targetId) {
  const marker = document.createElement('sup');
  const link = document.createElement('a');

  marker.className = 'study-source-marker';
  link.href = `#${targetId}`;
  link.setAttribute('aria-label', `Quelle ${number}`);
  link.textContent = number;
  marker.append(link);

  return marker;
}

function replaceSourceTokens(root, sourceTargets) {
  const textNodes = [];
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!node.nodeValue?.includes('[') || node.parentElement?.closest(EXCLUDED_SELECTOR)) {
        return NodeFilter.FILTER_REJECT;
      }

      return NodeFilter.FILTER_ACCEPT;
    },
  });

  while (walker.nextNode()) textNodes.push(walker.currentNode);

  for (const textNode of textNodes) {
    const text = textNode.nodeValue;
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let replaced = false;

    SOURCE_TOKEN_PATTERN.lastIndex = 0;

    for (const match of text.matchAll(SOURCE_TOKEN_PATTERN)) {
      const targetId = sourceTargets.get(match[1]);
      if (!targetId) continue;

      fragment.append(text.slice(lastIndex, match.index));
      fragment.append(createSourceMarker(match[1], targetId));
      lastIndex = match.index + match[0].length;
      replaced = true;
    }

    if (!replaced) continue;

    fragment.append(text.slice(lastIndex));
    textNode.replaceWith(fragment);
  }
}

function setupStudySourceLinks() {
  const sourceTargets = getSourceTargets();
  if (!sourceTargets.size) return;

  document.querySelectorAll(CONTENT_SELECTOR).forEach((root) => {
    replaceSourceTokens(root, sourceTargets);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupStudySourceLinks, { once: true });
} else {
  setupStudySourceLinks();
}

document.addEventListener('product:morph', setupStudySourceLinks);
document.addEventListener('shopify:section:load', setupStudySourceLinks);
